

export class UserStatusInput implements IUserStatusInput {
    /** The auto-generated id of the user master */
    userId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IUserStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserStatusInput {
    /** The auto-generated id of the user master */
    userId: number;
    /** The updated status */
    status: number;
}

